export type NavLinkItem = Readonly<{
  href: string;
  id: string;
  label: string;
}>;

// Primary site navigation links
const PRIMARY_LINKS: readonly NavLinkItem[] = [
  { href: '/hiv-test', id: 'our-product', label: 'Our Product' },
  { href: '/our-story', id: 'our-story', label: 'Our Story' },
  { href: '/our-network', id: 'our-network', label: 'Our Network' },
  { href: '/#faq', id: 'faq', label: 'FAQ' },
] as const;

// Resources links used across menus and footer
const RESOURCES_LINKS: readonly NavLinkItem[] = [
  { href: '/sti-info', id: 'sti-info', label: 'STI Info' },
  { href: '/resources', id: 'resources', label: 'Sexual Health Resources' },
  {
    href: '/interpreting-results',
    id: 'interpreting-results',
    label: 'Interpreting Your Results',
  },
] as const;

export function getPrimaryLinks(): readonly NavLinkItem[] {
  return PRIMARY_LINKS;
}

export function getResourceLinks(): readonly NavLinkItem[] {
  return RESOURCES_LINKS;
}

// Consolidated set for portal menus
export function getPortalMenuLinks(): readonly NavLinkItem[] {
  // Order: Our Story, Interpreting Results, Our Network, STI Info, Resources, FAQ
  const primary = PRIMARY_LINKS;
  const resources = RESOURCES_LINKS;
  const byId = new Map<string, NavLinkItem>(
    [...primary, ...resources].map(i => [i.id, i])
  );
  const order = [
    'our-story',
    'interpreting-results',
    'our-network',
    'sti-info',
    'resources',
    'faq',
  ];
  return order
    .map(id => byId.get(id))
    .filter((x): x is NavLinkItem => Boolean(x));
}
